import { DECORATION_CLASS } from './inlineSwatchTypes';

/**
 * Determine if the event target is an inline swatch decoration.
 */
export const isInlineSwatchDecorationTarget = (eventTarget: EventTarget | null): eventTarget is HTMLSpanElement => {
    if (!eventTarget) return false;
    if (!(eventTarget instanceof HTMLElement)) return false;
    return eventTarget.classList.contains(DECORATION_CLASS);
};

/**
 * Determine if a click has occurred on the swatch of an inline color decoration.
 */
export const isInlineSwatchPreviewClick = (event: MouseEvent) => {
    if (!isInlineSwatchDecorationTarget(event.target)) return false;

    const span = event.target;
    const spanBoundingRect = span.getBoundingClientRect();

    const clickX = event.clientX;
    const spanClickX = clickX - spanBoundingRect.left;

    // If the click is in the text, rather than the swatch, we don't want to open the colour picker
    if (spanClickX > 20) return false;

    return true;
};
